import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';


export const UserContext = createContext();

const initialFilters = {
    searchBy: 'name',
    searchValue: '',
    status: '',
    branch_id: [],

};

export function UserContextProvider({ children }) {
    const { user, setModalAlert, setOpenAlert, setAlertMessage, setSeverity } = useContext(CommonContext);

    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allUser, setAllUser] = useState([]);
    const [viewData, setViewData] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selected, setSelected] = useState([]);
    const [filters, setFilters] = useState(initialFilters);


    const handleAddModal = () => {
        setAddModal(true);
        setModalAlert(false);
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
    };

    const handleCloseModal = () => {
        setViewData('')
        setIsEdit(false);
        setAddModal(false);
    };
    console.log('user', user);
    const onLoadApi = (customFilters = filters) => {
        let payload = {
            ...customFilters,

            // admin_id: user?.user_type !== "Merchant" ? user?.id : null,
            // merchant_id: user?.user_type === "Merchant" ? user?.id : null,
        };

        // if (user?.user_type !== "Merchant") {
        //     payload.admin_id = user?.id;
        //     console.log('payload1', payload);
        // } else {
        //     payload.merchant_id = user?.id;
        //     console.log('payload2', payload);
        // }
        payload.admin_id = user?.id

        setAllUser([]);
        setAllData([]);
        setFirstLoading(false);
        commonApi.post(`/users/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllUser(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const viewDetail = (id) => {
        setIsLoading(true);
        commonApi.post('/users/view', { id: id, admin_id: user?.id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    setIsEdit(true);
                    setViewData(response?.data?.data);
                    handleAddModal();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }

    useEffect(() => {
        onLoadApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage]);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        filters,
        setFilters,
        initialFilters,
        viewDetail,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        selected,
        setSelected,
        isEdit,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        allUser,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllUser,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setIsEdit,
    };

    // Render the provider with children
    return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
}
